<template>
<div class="zt-h2-page">
  <div v-if="!parseInt(featured)">
    <div v-if="showHeader" class="flex flex-nowrap items-center justify-between mb-5 xl:mb-6">
      <h2 v-if="isMainPage" :class="{'!my-0 !font-semibold': sidebar}">
        <a href="/sporty-walk/" class="no-default-style">
          Gale <span class="text-zt-red">sportów walki</span>
        </a>
      </h2>
      <h2 v-else :class="{'!my-0 !font-semibold': sidebar}">
        Gale <span class="text-zt-red">sportów walki</span>
      </h2>
      <a v-if="!sidebar"
         class="only-desktop-flex underline text-[#93A3BA] text-sm flex-nowrap items-center cursor-pointer zt-hover
                no-default-style"
         href="/sporty-walk/" @click.prevent="handleCount('/sporty-walk', 'wszystkie_gale')">
        WSZYSTKIE GALE
        <svg width="16" height="12" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-3 cursor-pointer">
          <path d="M13.4789 14.7234L20.8406 7.36172L13.4789 0L12.2766 1.20234L17.6133 6.51797L4.21875 6.51797V8.20547L17.6133 8.20547L12.2766 13.5211L13.4789 14.7234Z" fill="#93A3BA"/>
          <path d="M1.6875 6.51797H0L0 8.20547H1.6875L1.6875 6.51797Z" fill="#93A3BA"/>
        </svg>
      </a>
    </div>
    <div class="mx-2" v-else-if="window.size.mobile && federation">
      <h2 class="!mt-0 !mb-4">Gale {{federation}}</h2>
    </div>

    <div v-if="dataLoading"
         class="w-full h-full mt-20 flex flex-col justify-center items-center lg:mt-10">
      <svg class="mr-2 w-8 h-8 animate-spin fill-zt-red" viewBox="0 0 100 101">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
      </svg>
      <span class="mt-4 animate-bounce">Ładowanie gal</span>
    </div>

    <div class="space-y-[10px] xl:mt-4">
      <h2 v-if="WP.id === 58061 && featuredGalas.length > 0" class="!mt-0 !mb-4">Główne wydarzenia</h2>
      <GalaItem v-for="gala in featuredGalas"
                :data="gala"
                :is-in-sidebar="!!+(isInSidebar) || isDetailsShown"
                :isFeaturedGala="true"
                :galaHour="gala.hour"
                :DefaultImagesSize="DefaultImagesSize"
                :isRelationPage="isRelationPage">
      </GalaItem>
      <h2 v-if="WP.id === 58061 && nextGalasToShow.length > 0" class="!mt-0 !mb-4">Nadchodzące</h2>
      <div v-else-if="!JSON.parse(isInSidebar) && nextGalasToShow.length > 0 && !isRelationPage" class="text-xl font-semibold mt-2.5"
            :class="{'ml-2': window.size.mobile, '!mt-0' : !JSON.parse(isInSidebar) && featuredGalas.length === 0}">Najbliższe</div>
      <p v-if="nextGalasToShow.length === 0 && featuredGalas.length === 0 && federation && isInSidebar && !dataLoading"
         class="text-xs text-zt-more text-center col-span-6 font-normal w-full-leading-[0.18px] py-2.5 rounded-zt
                border border-zt-light bg-zt-light-transparent">
        Brak zaplanowanych gal do wyświetlania
      </p>
      <GalaItem v-for="gala in nextGalasToShow"
                :data="gala"
								:is-in-sidebar="!!+(isInSidebar) || isDetailsShown"
                :isFeaturedGala="false"
                :galaHour="gala.hour"
                :DefaultImagesSize="DefaultImagesSize"
                :isRelationPage="isRelationPage">
      </GalaItem>
    </div>
    <div v-if="endedGalas.length > 0" class="space-y-[10px] mt-5 xl:mt-6" :class="[federation ? '!mt-2.5' : '', {'!mt-5': sidebar}, {'!mt-0' : isInSidebar === 'true'}]">
      <h2 v-if="WP.id === 58061" class="w-fit pl-2 h2-square mt-0 font-semibold mb-4">Ostatnie wyniki</h2>
      <span v-else-if="!JSON.parse(isInSidebar)" class="text-xl font-semibold mt-4" :class="{'ml-2': window.size.mobile }">Zakończone</span>
      <GalaItem v-for="gala in endedGalasToShow"
                :data="gala"
								:is-in-sidebar="!!+(isInSidebar) || isDetailsShown"
                :isFeaturedGala="false"
                :galaHour="gala.hour"
                :DefaultImagesSize="DefaultImagesSize"
                :isRelationPage="isRelationPage">
      </GalaItem>
    </div>
    <a v-if="isMainPage || sidebar"
       class="only-mobile-flex underline text-[#93A3BA] text-sm flex-nowrap items-center cursor-pointer zt-hover
              no-default-style justify-center mt-5" :style="sidebar ? 'display:flex' : ''" href="/sporty-walk/"
       @click.prevent="handleCount('/sporty-walk/', 'wszystkie_gale')">
      WSZYSTKIE GALE
      <svg width="16" height="12" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-3 cursor-pointer">
        <path d="M13.4789 14.7234L20.8406 7.36172L13.4789 0L12.2766 1.20234L17.6133 6.51797L4.21875 6.51797V8.20547L17.6133 8.20547L12.2766 13.5211L13.4789 14.7234Z" fill="#93A3BA"/>
        <path d="M1.6875 6.51797H0L0 8.20547H1.6875L1.6875 6.51797Z" fill="#93A3BA"/>
      </svg>
    </a>
    <button v-if="!isRelationPage" class="block mx-auto mt-6 mb-2"
            @click="endedGalasShowCount += 5"
            aria-label="Rozwiń">
      <span v-if="endedGalasShowCount < endedGalas.length"
           class="underline pt-5 text-sm zt-hover uppercase text-zt-more text-[14px] xl:pt-1">Rozwiń</span>
    </button>
  </div>
  <div v-else-if="featuredGalas.length > 0">
    <h2 v-if="WP.id === 58061" class="!mt-0 !mb-4">Główne wydarzenia</h2>
    <div class="space-y-[10px]">
      <GalaItem v-for="gala in featuredGalas" class="first:mt-4 last:!mb-4"
                :data="gala"
								:is-in-sidebar="!!+(isInSidebar) || isDetailsShown"
                :isFeaturedGala="true"
                :galaHour="gala.hour"
                :DefaultImagesSize="DefaultImagesSize"
                :isRelationPage="isRelationPage">
      </GalaItem>
    </div>
  </div>
</div>
</template>

<script>
import utils_mixin from '../mixins/utils_mixin';
import GalaItem from "../components/GalaItem.vue";
import {weekDayToString} from "../../assets/js/utils";

export default {
  name: 'FightGalas',
  components: {
    GalaItem
  },
  inject: ['WP'],
  mixins: [utils_mixin],
  props: {
    sidebar: {
      default: false,
      type: Boolean
    },
    likemainpage: {
      type: Boolean
    },
    featured: {
      default: '0',
      type: String
    },
		isInSidebar: {
			default: 'false',
			type: String
		},
    isDetailsShown: {
      default: true,
      type: Boolean
    },
    DefaultImagesSize: {
      default: false,
      type: Boolean
    },
    isRelationPage: {
      default: false,
      type: Boolean
    },
    galaId: {
      default: null,
      type: Boolean
    }
  },
  data() {
    return {
      featuredGalas: [],
      upcomingGalas: [],
      endedGalas: [],
      endedGalasShowCount: 2,
      isMainPage: null,
      galasCount: this.$attrs['count'] ?? null,
      federation: this.$attrs['federation'] ?? null,
      dataLoading: true,
    }
  },
  mounted() {
		this.isMainPage = this.WP.id === 5 || this.likemainpage;
		if(JSON.parse(this.isInSidebar)) {
			this.loadSidebarGalas();
			this.endedGalasShowCount = 6;
			return;
		}
    if (parseInt(this.$props.featured)) {
      this.loadFeaturedGalas();
    } else {
      this.loadEndedGalas();
    }
    if (this.galasCount){
      this.endedGalasShowCount = parseInt(this.galasCount);
    }
    setTimeout(this.refreshTooltips, 500);
  },
  computed: {
    endedGalasToShow() {
      if (this.endedGalas.length > 0) {
        if (this.federation) {
          return this.endedGalas.slice(0, this.endedGalasShowCount);
        } else {
          if (this.isRelationPage) {
            return this.endedGalas.slice().filter(el => {
              return el.is_relation_planned === '1' && Number(this.galaId) !== Number(el.id);
            }).slice(0,3)
          } else if (this.isMainPage || this.sidebar) {
            return this.endedGalas.filter(gala => gala.federation_name !== 'High League')
              .slice(0, this.endedGalasShowCount);
          } else {
            return this.endedGalas.slice(0, this.endedGalasShowCount);
          }
        }
      } else return [];
    },
    nextGalasToShow() {
      if (this.upcomingGalas.length > 0) {
        if (this.isMainPage || this.sidebar) {
          return this.upcomingGalas.filter(gala => gala.federation_name !== 'High League');
        } else {
          if (this.isRelationPage) {
            return this.upcomingGalas.slice().filter(el => {
              return el.is_relation_planned === '1' && Number(this.galaId) !== Number(el.id);
            }).reverse()
          }
          if (this.federation !== null) {
            return this.upcomingGalas.sort((a,b) => {
              return a.timestamp - b.timestamp
            });
          } else {
            return this.upcomingGalas.sort((a,b) => {
              return b.timestamp - a.timestamp
            });
          }
        }
      } else {
        return [];
      }
    },
    showHeader() {
      return this.likemainpage ? false : (this.isMainPage || this.sidebar);
    }
  },
  methods: {
    loadFeaturedGalas() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_ended_galas',
          is_main_page: this.isMainPage || this.sidebar,
          featured: true
        })
        .then(response => {
          if (response.data.success) {
            this.featuredGalas = response.data.data;
            this.featuredGalas.forEach(gala => {
              gala.formatedGalaDate = this.formatGalaDate(gala.timestamp, gala.hour, gala.month);
            });
            this.dataLoading = false;
          }
        });
    },
		loadSidebarGalas() {
			axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_ended_galas',
          is_main_page: false,
          is_sidebar: true
			  }).then(response => {
          this.endedGalas = response.data.data.slice(0,6);
          this.endedGalas.forEach(gala => {
            gala.formatedGalaDate = this.formatGalaDate(gala.timestamp, gala.hour, gala.month);
          });
          this.dataLoading = false;
      });
		},
    loadEndedGalas() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_ended_galas',
          is_main_page: this.isMainPage || this.sidebar,
          galas_count: this.galasCount,
          federation: this.federation,
        })
        .then(response => {
          if (response.data.success) {
            this.endedGalas = response.data.data.ended_galas;
            this.upcomingGalas = response.data.data.next_galas;
            this.featuredGalas = response.data.data.featured_galas;
            this.endedGalas.forEach(gala => {
              gala.formatedGalaDate = this.formatGalaDate(gala.timestamp, gala.hour, gala.month);
            });
            this.upcomingGalas.forEach(gala => {
              gala.formatedGalaDate = this.formatGalaDate(gala.timestamp, gala.hour, gala.month);
            });
            this.featuredGalas.forEach(gala => {
              gala.formatedGalaDate = this.formatGalaDate(gala.timestamp, gala.hour, gala.month);
            });
            this.dataLoading = false;
          }
        });
    },
    formatGalaDate(timestamp, hour, month) {
      let now = DateTime.now().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      let galaDate = DateTime.fromSeconds(timestamp);
      if (month.length <= 7) {
        let splitedDate = month.split('-');
        return galaDate.toFormat('LLLL') + ' ' + splitedDate[1];
      }
      let diff = galaDate.diff(now, ['days', 'hours', 'minutes']);
      if (JSON.parse(this.isInSidebar) && diff.days < 0) {
        return 'Zakończono';
      } else if (diff.days === -1) {
        return 'Wczoraj';
      } else if (diff.days === 0) {
        return 'Dziś ' + (hour.length > 0 ? ' (' + hour + ')' : '');
      } else if (diff.days === 1) {
        return 'Jutro ' + (hour.length > 0 ? ' (' + hour + ')' : '');
      } else if (diff.days > 1 && diff.days < 7) {
        let stringDate = galaDate.toFormat('EEEE') + (hour.length > 0 ? ' (' + hour + ')' : '');
        return stringDate.charAt(0).toUpperCase() + stringDate.slice(1);
      } else if (diff.days < 0 && diff.days > -7) {
        return (window.size.desktop ? `${-diff.days} dni temu` : `${-diff.days} d. temu`) + ' ' + (this.isRelationPage ? (hour.length > 0 ? ' (' + hour + ')' : '') : '');
      } else {
        if (now.year !== galaDate.year) {
          return galaDate.toFormat('d MMMM yyyy')
        }
        return galaDate.toFormat('d MMMM') + (this.isRelationPage > 0 ? (hour.length > 0 ? ' (' + weekDayToString(galaDate.weekday) + ', ' + hour + ')' : '') : '');
      }
    },
    handleCount(link, galaName) {
      if (this.isMainPage) {
        countClicks('Główna gale').then(() => {
          window.location = link;
        });
      } else if (this.sidebar) {
        countClicks(`sidebar_sporty_${window.size.mobile}`).then(() => {
            window.location = link;
        });
      } else {
        window.location = link;
      }
    }
  }
}
</script>